import React from 'react';
import { bool, func } from 'prop-types';

import LoadingState from '../../../LoadingState';

import s from './GetLatestRecord.css';


const GetLatestRecord  = ({ ...props }) =>
  <button
    className={s.component}
    id="requestHealthRecordBtn"
    disabled={props.loadingState}
    onClick={props.getLatestRecord}
  >
    {props.loadingState ? (
      <LoadingState context="requestHealthRecordBtn" />
    ) : (
      'Request Health Record'
    )}
  </button>;

/**
 * @props
 * loadingState = boolean value returned when GET_LATEST_RECORD is invoked
 * getLatestRecord = callback function bound in the LandingPage
 */
GetLatestRecord.propTypes = {
  loadingState: bool,
  getLatestRecord: func,
};

export default GetLatestRecord;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/GetLatestRecord/GetLatestRecord.js